<template>
  <div class="admin-page">
    <h2 class="page-title">充值订单审核</h2>
    <p class="page-hint">C 端仅开放微信支付。此处处理待入账订单（含线下/对公），通过后入账并发站内信。支付宝回调仍未接入。</p>
    <div class="admin-toolbar">
      <el-select v-model="filters.status" placeholder="状态" clearable @change="fetchList">
        <el-option label="待审核" value="pending" />
        <el-option label="已入账" value="completed" />
        <el-option label="已拒绝" value="rejected" />
        <el-option label="失败" value="failed" />
      </el-select>
      <el-select v-model="filters.payMethod" placeholder="支付方式" clearable @change="fetchList">
        <el-option label="微信" :value="1" />
        <el-option label="支付宝" :value="2" />
      </el-select>
      <el-button type="primary" @click="fetchList">查询</el-button>
    </div>
    <el-table :data="items" v-loading="loading" border>
      <el-table-column prop="id" label="ID" width="70" />
      <el-table-column prop="userId" label="用户ID" width="90" />
      <el-table-column prop="orderNo" label="订单号" min-width="180" show-overflow-tooltip />
      <el-table-column label="金额（元）" width="110">
        <template #default="s">{{ (Number(s.row.amount || 0) / 100).toFixed(2) }}</template>
      </el-table-column>
      <el-table-column label="方式" width="90">
        <template #default="s">{{ payLabel(s.row.payMethod) }}</template>
      </el-table-column>
      <el-table-column prop="status" label="状态" width="90">
        <template #default="s">{{ statusLabel(s.row.status) }}</template>
      </el-table-column>
      <el-table-column prop="remark" label="备注" min-width="140" show-overflow-tooltip />
      <el-table-column label="创建时间" width="170">
        <template #default="s">{{ formatTime(s.row.createdAt) }}</template>
      </el-table-column>
      <el-table-column label="操作" width="160" fixed="right">
        <template #default="s">
          <template v-if="s.row.status === 'pending'">
            <el-button link type="success" @click="review(s.row, 'approve')">通过入账</el-button>
            <el-button link type="danger" @click="openReject(s.row)">拒绝</el-button>
          </template>
          <span v-else>—</span>
        </template>
      </el-table-column>
    </el-table>
    <AdminPagination
      v-model:current-page="page"
      v-model:page-size="pageSize"
      :total="total"
      @size-change="fetchList"
      @current-change="fetchList"
    />

    <el-dialog v-model="rejectVisible" title="拒绝充值订单" width="420px">
      <el-input v-model="rejectReason" type="textarea" :rows="3" placeholder="拒绝原因（用户会收到站内信）" />
      <template #footer>
        <el-button @click="rejectVisible = false">取消</el-button>
        <el-button type="danger" :loading="processing" @click="confirmReject">确认拒绝</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios'
import AdminPagination from '@/components/AdminPagination.vue'

export default {
  name: 'AdminRechargeManagement',
  components: { AdminPagination },
  data() {
    return {
      loading: false,
      processing: false,
      items: [],
      total: 0,
      page: 1,
      pageSize: 20,
      filters: { status: 'pending', payMethod: '' },
      rejectVisible: false,
      rejectReason: '',
      currentRow: null
    }
  },
  created() {
    this.fetchList()
  },
  methods: {
    authHeaders() {
      const token = localStorage.getItem('jwt_token')
      return token ? { Authorization: `Bearer ${token}` } : {}
    },
    payLabel(m) {
      if (Number(m) === 1) return '微信'
      if (Number(m) === 2) return '支付宝'
      return '其他'
    },
    statusLabel(s) {
      return ({ pending: '待审核', completed: '已入账', rejected: '已拒绝', failed: '失败' })[s] || s
    },
    formatTime(ts) {
      if (!ts) return '—'
      const n = Number(ts)
      if (!Number.isFinite(n) || n <= 0) return '—'
      return new Date(n * 1000).toLocaleString()
    },
    async fetchList() {
      this.loading = true
      try {
        const res = await axios.post('/api/v1/admin/recharge/list', {
          page: this.page,
          pageSize: this.pageSize,
          status: this.filters.status || undefined,
          payMethod: Number(this.filters.payMethod) || 0
        }, { headers: this.authHeaders() })
        if (res.data?.code !== 200) {
          this.$message.error(res.data?.message || '加载失败')
          return
        }
        this.items = res.data.data?.orders || []
        this.total = res.data.data?.total || 0
      } catch (e) {
        this.$message.error(e.message || '加载失败')
      } finally {
        this.loading = false
      }
    },
    async review(row, action, reason = '') {
      this.processing = true
      try {
        const res = await axios.post('/api/v1/admin/recharge/approve-reject', {
          orderNo: row.orderNo,
          action,
          reason
        }, { headers: this.authHeaders() })
        if (res.data?.code !== 200) {
          this.$message.error(res.data?.message || '处理失败')
          return
        }
        this.$message.success('处理成功')
        this.fetchList()
      } catch (e) {
        this.$message.error(e.message || '处理失败')
      } finally {
        this.processing = false
      }
    },
    openReject(row) {
      this.currentRow = row
      this.rejectReason = ''
      this.rejectVisible = true
    },
    confirmReject() {
      if (!this.rejectReason.trim()) {
        this.$message.warning('请填写拒绝原因')
        return
      }
      this.review(this.currentRow, 'reject', this.rejectReason.trim())
      this.rejectVisible = false
    }
  }
}
</script>

<style scoped>
.page-title { margin: 0 0 8px; }
.page-hint { margin: 0 0 16px; color: #5c6370; font-size: 13px; }
.admin-toolbar { display: flex; flex-wrap: wrap; gap: 12px; margin-bottom: 16px; }
</style>
